import { render, staticRenderFns } from "./GeneralAgentFormInfo.vue?vue&type=template&id=8468d4e8&scoped=true&"
import script from "./GeneralAgentFormInfo.vue?vue&type=script&lang=ts&"
export * from "./GeneralAgentFormInfo.vue?vue&type=script&lang=ts&"
import style0 from "./GeneralAgentFormInfo.vue?vue&type=style&index=0&id=8468d4e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8468d4e8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
